module.exports = __webpack_public_path__ + "img/certificat2.15d8f370.svg";